export default __webpack_public_path__ + "static/media/shape-1.b380d9fe.svg";